export enum ExecutionPermission {
  Admin,
  Title,
  Governor,
  CabinetSecretary,
  AllStateOfficials,
  GeneralPublic,
}
